import { NoxusIcon } from "@/components/shadcn/icons";
import {
  AlertCircle,
  AppWindow,
  Banknote,
  Bolt,
  Book,
  BookOpen,
  Bot,
  BotMessageSquare,
  Brain,
  Briefcase,
  Building2,
  Calendar,
  CalendarCheck,
  CheckCircle,
  Cloud,
  Coffee,
  Cpu,
  Database,
  Dna,
  Factory,
  FileCheck,
  FileSpreadsheet,
  FileText,
  FileUp,
  FlaskConical,
  Gavel,
  GitBranch,
  GitCompare,
  HardDrive,
  Headset,
  Heart,
  Home,
  Inbox,
  KeyRound,
  Landmark,
  Library,
  ListChecks,
  LucideIcon,
  Mail,
  MessageSquare,
  Mountain,
  Network,
  Package,
  Plug,
  NotebookPen,
  Phone,
  Pill,
  ScanText,
  Search,
  Send,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  Siren,
  Smartphone,
  Stethoscope,
  Ticket,
  TrendingUp,
  Truck,
  User,
  UserCheck,
  UserCircle,
  UserPlus,
  Users,
  Filter,
  ScanSearch,
  Table2,
  Workflow,
  Zap,
} from "lucide-react";

const TEXTS = {
  COUNTRIES: {
    AFGHANISTAN: "Afghanistan",
    ALBANIA: "Albania",
    ALGERIA: "Algeria",
    AMERICAN_SAMOA: "American Samoa",
    ANDORRA: "Andorra",
    ANGOLA: "Angola",
    ANGUILLA: "Anguilla",
    ANTIGUA_AND_BARBUDA: "Antigua and Barbuda",
    ARGENTINA: "Argentina",
    ARMENIA: "Armenia",
    ARUBA: "Aruba",
    AUSTRALIA: "Australia",
    AUSTRIA: "Austria",
    AZERBAIJAN: "Azerbaijan",
    BAHAMAS: "Bahamas",
    BAHRAIN: "Bahrain",
    BANGLADESH: "Bangladesh",
    BARBADOS: "Barbados",
    BELARUS: "Belarus",
    BELGIUM: "Belgium",
    BELIZE: "Belize",
    BENIN: "Benin",
    BERMUDA: "Bermuda",
    BHUTAN: "Bhutan",
    BOLIVIA: "Bolivia",
    BOSNIA_AND_HERZEGOVINA: "Bosnia and Herzegovina",
    BOTSWANA: "Botswana",
    BRAZIL: "Brazil",
    BRITISH_INDIAN_OCEAN_TERRITORY: "British Indian Ocean Territory",
    BRITISH_VIRGIN_ISLANDS: "British Virgin Islands",
    BRUNEI: "Brunei",
    BULGARIA: "Bulgaria",
    BURKINA_FASO: "Burkina Faso",
    BURUNDI: "Burundi",
    CAMBODIA: "Cambodia",
    CAMEROON: "Cameroon",
    CANADA: "Canada",
    CAPE_VERDE: "Cape Verde",
    CAYMAN_ISLANDS: "Cayman Islands",
    CENTRAL_AFRICAN_REPUBLIC: "Central African Republic",
    CHAD: "Chad",
    CHILE: "Chile",
    CHINA: "China",
    CHRISTMAS_ISLAND: "Christmas Island",
    COCOS_ISLANDS: "Cocos Islands",
    COLOMBIA: "Colombia",
    COMOROS: "Comoros",
    COOK_ISLANDS: "Cook Islands",
    COSTA_RICA: "Costa Rica",
    CROATIA: "Croatia",
    CUBA: "Cuba",
    CURAÇAO: "Curaçao",
    CYPRUS: "Cyprus",
    CZECH_REPUBLIC: "Czech Republic",
    DEMOCRATIC_REPUBLIC_OF_THE_CONGO: "Democratic Republic of the Congo",
    DENMARK: "Denmark",
    DJIBOUTI: "Djibouti",
    DOMINICA: "Dominica",
    DOMINICAN_REPUBLIC: "Dominican Republic",
    ECUADOR: "Ecuador",
    EGYPT: "Egypt",
    EL_SALVADOR: "El Salvador",
    EQUATORIAL_GUINEA: "Equatorial Guinea",
    ERITREA: "Eritrea",
    ESTONIA: "Estonia",
    ESWATINI: "Eswatini",
    ETHIOPIA: "Ethiopia",
    FALKLAND_ISLANDS: "Falkland Islands",
    FAROE_ISLANDS: "Faroe Islands",
    FIJI: "Fiji",
    FINLAND: "Finland",
    FRANCE: "France",
    FRENCH_GUIANA: "French Guiana",
    FRENCH_POLYNESIA: "French Polynesia",
    GABON: "Gabon",
    GAMBIA: "Gambia",
    GEORGIA: "Georgia",
    GERMANY: "Germany",
    GHANA: "Ghana",
    GIBRALTAR: "Gibraltar",
    GREECE: "Greece",
    GREENLAND: "Greenland",
    GRENADA: "Grenada",
    GUAM: "Guam",
    GUATEMALA: "Guatemala",
    GUERNSEY: "Guernsey",
    GUINEA: "Guinea",
    GUINEA_BISSAU: "Guinea-Bissau",
    GUYANA: "Guyana",
    HAITI: "Haiti",
    HONDURAS: "Honduras",
    HONG_KONG: "Hong Kong",
    HUNGARY: "Hungary",
    ICELAND: "Iceland",
    INDIA: "India",
    INDONESIA: "Indonesia",
    IRAN: "Iran",
    IRAQ: "Iraq",
    IRELAND: "Ireland",
    ISLE_OF_MAN: "Isle of Man",
    ISRAEL: "Israel",
    ITALY: "Italy",
    IVORY_COAST: "Ivory Coast",
    JAMAICA: "Jamaica",
    JAPAN: "Japan",
    JERSEY: "Jersey",
    JORDAN: "Jordan",
    KAZAKHSTAN: "Kazakhstan",
    KENYA: "Kenya",
    KIRIBATI: "Kiribati",
    KUWAIT: "Kuwait",
    KYRGYZSTAN: "Kyrgyzstan",
    LAOS: "Laos",
    LATVIA: "Latvia",
    LEBANON: "Lebanon",
    LESOTHO: "Lesotho",
    LIBERIA: "Liberia",
    LIBYA: "Libya",
    LIECHTENSTEIN: "Liechtenstein",
    LITHUANIA: "Lithuania",
    LUXEMBOURG: "Luxembourg",
    MACAO: "Macao",
    MACEDONIA: "Macedonia",
    MADAGASCAR: "Madagascar",
    MALAWI: "Malawi",
    MALAYSIA: "Malaysia",
    MALDIVES: "Maldives",
    MALI: "Mali",
    MALTA: "Malta",
    MARSHALL_ISLANDS: "Marshall Islands",
    MAURITANIA: "Mauritania",
    MAURITIUS: "Mauritius",
    MAYOTTE: "Mayotte",
    MEXICO: "Mexico",
    MICRONESIA: "Micronesia",
    MOLDOVA: "Moldova",
    MONACO: "Monaco",
    MONGOLIA: "Mongolia",
    MONTENEGRO: "Montenegro",
    MONTSERRAT: "Montserrat",
    MOROCCO: "Morocco",
    MOZAMBIQUE: "Mozambique",
    MYANMAR: "Myanmar",
    NAMIBIA: "Namibia",
    NAURU: "Nauru",
    NEPAL: "Nepal",
    NETHERLANDS: "Netherlands",
    NEW_CALEDONIA: "New Caledonia",
    NEW_ZEALAND: "New Zealand",
    NICARAGUA: "Nicaragua",
    NIGER: "Niger",
    NIGERIA: "Nigeria",
    NIUE: "Niue",
    NORTH_KOREA: "North Korea",
    NORTHERN_MARIANA_ISLANDS: "Northern Mariana Islands",
    NORWAY: "Norway",
    OMAN: "Oman",
    PAKISTAN: "Pakistan",
    PALAU: "Palau",
    PALESTINE: "Palestine",
    PANAMA: "Panama",
    PAPUA_NEW_GUINEA: "Papua New Guinea",
    PARAGUAY: "Paraguay",
    PERU: "Peru",
    PHILIPPINES: "Philippines",
    PITCAIRN: "Pitcairn",
    POLAND: "Poland",
    PORTUGAL: "Portugal",
    PUERTO_RICO: "Puerto Rico",
    QATAR: "Qatar",
    REUNION: "Reunion",
    ROMANIA: "Romania",
    RUSSIA: "Russia",
    RWANDA: "Rwanda",
    SAINT_HELENA: "Saint Helena",
    SAINT_KITTS_AND_NEVIS: "Saint Kitts and Nevis",
    SAINT_LUCIA: "Saint Lucia",
    SAINT_MARTIN: "Saint Martin",
    SAINT_PIERRE_AND_MIQUELON: "Saint Pierre and Miquelon",
    SAINT_VINCENT_AND_THE_GRENADINES: "Saint Vincent and The Grenadines",
    SAMOA: "Samoa",
    SAN_MARINO: "San Marino",
    SAO_TOME_AND_PRINCIPE: "Sao Tome and Principe",
    SAUDI_ARABIA: "Saudi Arabia",
    SENEGAL: "Senegal",
    SERBIA: "Serbia",
    SEYCHELLES: "Seychelles",
    SIERRA_LEONE: "Sierra Leone",
    SINGAPORE: "Singapore",
    SINT_MAARTEN: "Sint Maarten",
    SLOVAKIA: "Slovakia",
    SLOVENIA: "Slovenia",
    SOLOMON_ISLANDS: "Solomon Islands",
    SOMALIA: "Somalia",
    SOUTH_AFRICA: "South Africa",
    SOUTH_KOREA: "South Korea",
    SOUTH_SUDAN: "South Sudan",
    SPAIN: "Spain",
    SRI_LANKA: "Sri Lanka",
    SUDAN: "Sudan",
    SURINAME: "Suriname",
    SVALBARD_AND_JAN_MAYEN: "Svalbard and Jan Mayen",
    SWEDEN: "Sweden",
    SWITZERLAND: "Switzerland",
    SYRIA: "Syria",
    TAIWAN: "Taiwan",
    TAJIKISTAN: "Tajikistan",
    TANZANIA: "Tanzania",
    THAILAND: "Thailand",
    TIMOR_LESTE: "Timor-leste",
    TOGO: "Togo",
    TOKELAU: "Tokelau",
    TONGA: "Tonga",
    TRINIDAD_AND_TOBAGO: "Trinidad and Tobago",
    TUNISIA: "Tunisia",
    TURKEY: "Turkey",
    TURKMENISTAN: "Turkmenistan",
    TURKS_AND_CAICOS_ISLANDS: "Turks and Caicos Islands",
    TUVALU: "Tuvalu",
    US_VIRGIN_ISLANDS: "U.S. Virgin Islands",
    UGANDA: "Uganda",
    UKRAINE: "Ukraine",
    UNITED_ARAB_EMIRATES: "United Arab Emirates",
    UNITED_KINGDOM: "United Kingdom",
    UNITED_STATES: "United States",
    URUGUAY: "Uruguay",
    UZBEKISTAN: "Uzbekistan",
    VANUATU: "Vanuatu",
    VATICAN: "Vatican",
    VENEZUELA: "Venezuela",
    VIETNAM: "Vietnam",
    WALLIS_AND_FUTUNA: "Wallis and Futuna",
    WESTERN_SAHARA: "Western Sahara",
    YEMEN: "Yemen",
    ZAMBIA: "Zambia",
    ZIMBABWE: "Zimbabwe",
  },
  LANGUAGES: {
    ARABIC: "Arabic",
    BENGALI: "Bengali",
    CHINESE: "Chinese",
    ENGLISH: "English",
    FRENCH: "French",
    GERMAN: "German",
    GUJARATI: "Gujarati",
    HINDI: "Hindi",
    INDONESIAN: "Indonesian",
    ITALIAN: "Italian",
    JAPANESE: "Japanese",
    JAVANESE: "Javanese",
    KANNADA: "Kannada",
    KOREAN: "Korean",
    MALAY: "Malay",
    MALAYALAM: "Malayalam",
    MARATHI: "Marathi",
    ORIYA: "Oriya",
    PERSIAN: "Persian",
    POLISH: "Polish",
    PORTUGUESE: "Portuguese",
    PUNJABI: "Punjabi",
    RUSSIAN: "Russian",
    SPANISH: "Spanish",
    TAMIL: "Tamil",
    TELUGU: "Telugu",
    TURKISH: "Turkish",
    URDU: "Urdu",
    VIETNAMESE: "Vietnamese",
    WU: "Wu",
  },
};

const categoryOptions = [
  { value: "Activism", label: "Activism" },
  { value: "Animals", label: "Animals" },
  { value: "Art & DIY", label: "Art & DIY" },
  { value: "Beauty & Fashion", label: "Beauty & Fashion" },
  { value: "Business", label: "Business" },
  { value: "Cars", label: "Cars" },
  { value: "Education", label: "Education" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Family", label: "Family" },
  { value: "Food", label: "Food" },
  { value: "Gaming", label: "Gaming" },
  { value: "Health & Fitness", label: "Health & Fitness" },
  { value: "Home", label: "Home" },
  { value: "Lifestyle", label: "Lifestyle" },
  { value: "Music", label: "Music" },
  { value: "Religion", label: "Religion" },
  { value: "Science", label: "Science" },
  { value: "Sports", label: "Sports" },
  { value: "Technology", label: "Technology" },
  { value: "Travel", label: "Travel" },
];

const countriesOptions = [
  { value: "Afghanistan", label: TEXTS.COUNTRIES.AFGHANISTAN },
  { value: "Albania", label: TEXTS.COUNTRIES.ALBANIA },
  { value: "Algeria", label: TEXTS.COUNTRIES.ALGERIA },
  { value: "American Samoa", label: TEXTS.COUNTRIES.AMERICAN_SAMOA },
  { value: "Andorra", label: TEXTS.COUNTRIES.ANDORRA },
  { value: "Angola", label: TEXTS.COUNTRIES.ANGOLA },
  { value: "Anguilla", label: TEXTS.COUNTRIES.ANGUILLA },
  {
    value: "Antigua and Barbuda",
    label: TEXTS.COUNTRIES.ANTIGUA_AND_BARBUDA,
  },
  { value: "Argentina", label: TEXTS.COUNTRIES.ARGENTINA },
  { value: "Armenia", label: TEXTS.COUNTRIES.ARMENIA },
  { value: "Aruba", label: TEXTS.COUNTRIES.ARUBA },
  { value: "Australia", label: TEXTS.COUNTRIES.AUSTRALIA },
  { value: "Austria", label: TEXTS.COUNTRIES.AUSTRIA },
  { value: "Azerbaijan", label: TEXTS.COUNTRIES.AZERBAIJAN },
  { value: "Bahamas", label: TEXTS.COUNTRIES.BAHAMAS },
  { value: "Bahrain", label: TEXTS.COUNTRIES.BAHRAIN },
  { value: "Bangladesh", label: TEXTS.COUNTRIES.BANGLADESH },
  { value: "Barbados", label: TEXTS.COUNTRIES.BARBADOS },
  { value: "Belarus", label: TEXTS.COUNTRIES.BELARUS },
  { value: "Belgium", label: TEXTS.COUNTRIES.BELGIUM },
  { value: "Belize", label: TEXTS.COUNTRIES.BELIZE },
  { value: "Benin", label: TEXTS.COUNTRIES.BENIN },
  { value: "Bermuda", label: TEXTS.COUNTRIES.BERMUDA },
  { value: "Bhutan", label: TEXTS.COUNTRIES.BHUTAN },
  { value: "Bolivia", label: TEXTS.COUNTRIES.BOLIVIA },
  {
    value: "Bosnia and Herzegovina",
    label: TEXTS.COUNTRIES.BOSNIA_AND_HERZEGOVINA,
  },
  { value: "Botswana", label: TEXTS.COUNTRIES.BOTSWANA },
  { value: "Brazil", label: TEXTS.COUNTRIES.BRAZIL },
  {
    value: "British Indian Ocean Territory",
    label: TEXTS.COUNTRIES.BRITISH_INDIAN_OCEAN_TERRITORY,
  },
  {
    value: "British Virgin Islands",
    label: TEXTS.COUNTRIES.BRITISH_VIRGIN_ISLANDS,
  },
  { value: "Brunei", label: TEXTS.COUNTRIES.BRUNEI },
  { value: "Bulgaria", label: TEXTS.COUNTRIES.BULGARIA },
  { value: "Burkina Faso", label: TEXTS.COUNTRIES.BURKINA_FASO },
  { value: "Burundi", label: TEXTS.COUNTRIES.BURUNDI },
  { value: "Cambodia", label: TEXTS.COUNTRIES.CAMBODIA },
  { value: "Cameroon", label: TEXTS.COUNTRIES.CAMEROON },
  { value: "Canada", label: TEXTS.COUNTRIES.CANADA },
  { value: "Cape Verde", label: TEXTS.COUNTRIES.CAPE_VERDE },
  { value: "Cayman Islands", label: TEXTS.COUNTRIES.CAYMAN_ISLANDS },
  {
    value: "Central African Republic",
    label: TEXTS.COUNTRIES.CENTRAL_AFRICAN_REPUBLIC,
  },
  { value: "Chad", label: TEXTS.COUNTRIES.CHAD },
  { value: "Chile", label: TEXTS.COUNTRIES.CHILE },
  { value: "China", label: TEXTS.COUNTRIES.CHINA },
  {
    value: "Christmas Island",
    label: TEXTS.COUNTRIES.CHRISTMAS_ISLAND,
  },
  { value: "Cocos Islands", label: TEXTS.COUNTRIES.COCOS_ISLANDS },
  { value: "Colombia", label: TEXTS.COUNTRIES.COLOMBIA },
  { value: "Comoros", label: TEXTS.COUNTRIES.COMOROS },
  { value: "Cook Islands", label: TEXTS.COUNTRIES.COOK_ISLANDS },
  { value: "Costa Rica", label: TEXTS.COUNTRIES.COSTA_RICA },
  { value: "Croatia", label: TEXTS.COUNTRIES.CROATIA },
  { value: "Cuba", label: TEXTS.COUNTRIES.CUBA },
  { value: "Curaçao", label: TEXTS.COUNTRIES.CURAÇAO },
  { value: "Cyprus", label: TEXTS.COUNTRIES.CYPRUS },
  { value: "Czech Republic", label: TEXTS.COUNTRIES.CZECH_REPUBLIC },
  {
    value: "Democratic Republic of the Congo",
    label: TEXTS.COUNTRIES.DEMOCRATIC_REPUBLIC_OF_THE_CONGO,
  },
  { value: "Denmark", label: TEXTS.COUNTRIES.DENMARK },
  { value: "Djibouti", label: TEXTS.COUNTRIES.DJIBOUTI },
  { value: "Dominica", label: TEXTS.COUNTRIES.DOMINICA },
  {
    value: "Dominican Republic",
    label: TEXTS.COUNTRIES.DOMINICAN_REPUBLIC,
  },
  { value: "Ecuador", label: TEXTS.COUNTRIES.ECUADOR },
  { value: "Egypt", label: TEXTS.COUNTRIES.EGYPT },
  { value: "El Salvador", label: TEXTS.COUNTRIES.EL_SALVADOR },
  {
    value: "Equatorial Guinea",
    label: TEXTS.COUNTRIES.EQUATORIAL_GUINEA,
  },
  { value: "Eritrea", label: TEXTS.COUNTRIES.ERITREA },
  { value: "Estonia", label: TEXTS.COUNTRIES.ESTONIA },
  { value: "Eswatini", label: TEXTS.COUNTRIES.ESWATINI },
  { value: "Ethiopia", label: TEXTS.COUNTRIES.ETHIOPIA },
  {
    value: "Falkland Islands",
    label: TEXTS.COUNTRIES.FALKLAND_ISLANDS,
  },
  { value: "Faroe Islands", label: TEXTS.COUNTRIES.FAROE_ISLANDS },
  { value: "Fiji", label: TEXTS.COUNTRIES.FIJI },
  { value: "Finland", label: TEXTS.COUNTRIES.FINLAND },
  { value: "France", label: TEXTS.COUNTRIES.FRANCE },
  { value: "French Guiana", label: TEXTS.COUNTRIES.FRENCH_GUIANA },
  {
    value: "French Polynesia",
    label: TEXTS.COUNTRIES.FRENCH_POLYNESIA,
  },
  { value: "Gabon", label: TEXTS.COUNTRIES.GABON },
  { value: "Gambia", label: TEXTS.COUNTRIES.GAMBIA },
  { value: "Georgia", label: TEXTS.COUNTRIES.GEORGIA },
  { value: "Germany", label: TEXTS.COUNTRIES.GERMANY },
  { value: "Ghana", label: TEXTS.COUNTRIES.GHANA },
  { value: "Gibraltar", label: TEXTS.COUNTRIES.GIBRALTAR },
  { value: "Greece", label: TEXTS.COUNTRIES.GREECE },
  { value: "Greenland", label: TEXTS.COUNTRIES.GREENLAND },
  { value: "Grenada", label: TEXTS.COUNTRIES.GRENADA },
  { value: "Guam", label: TEXTS.COUNTRIES.GUAM },
  { value: "Guatemala", label: TEXTS.COUNTRIES.GUATEMALA },
  { value: "Guernsey", label: TEXTS.COUNTRIES.GUERNSEY },
  { value: "Guinea", label: TEXTS.COUNTRIES.GUINEA },
  { value: "Guinea-Bissau", label: TEXTS.COUNTRIES.GUINEA_BISSAU },
  { value: "Guyana", label: TEXTS.COUNTRIES.GUYANA },
  { value: "Haiti", label: TEXTS.COUNTRIES.HAITI },
  { value: "Honduras", label: TEXTS.COUNTRIES.HONDURAS },
  { value: "Hong Kong", label: TEXTS.COUNTRIES.HONG_KONG },
  { value: "Hungary", label: TEXTS.COUNTRIES.HUNGARY },
  { value: "Iceland", label: TEXTS.COUNTRIES.ICELAND },
  { value: "India", label: TEXTS.COUNTRIES.INDIA },
  { value: "Indonesia", label: TEXTS.COUNTRIES.INDONESIA },
  { value: "Iran", label: TEXTS.COUNTRIES.IRAN },
  { value: "Iraq", label: TEXTS.COUNTRIES.IRAQ },
  { value: "Ireland", label: TEXTS.COUNTRIES.IRELAND },
  { value: "Isle of Man", label: TEXTS.COUNTRIES.ISLE_OF_MAN },
  { value: "Israel", label: TEXTS.COUNTRIES.ISRAEL },
  { value: "Italy", label: TEXTS.COUNTRIES.ITALY },
  { value: "Ivory Coast", label: TEXTS.COUNTRIES.IVORY_COAST },
  { value: "Jamaica", label: TEXTS.COUNTRIES.JAMAICA },
  { value: "Japan", label: TEXTS.COUNTRIES.JAPAN },
  { value: "Jersey", label: TEXTS.COUNTRIES.JERSEY },
  { value: "Jordan", label: TEXTS.COUNTRIES.JORDAN },
  { value: "Kazakhstan", label: TEXTS.COUNTRIES.KAZAKHSTAN },
  { value: "Kenya", label: TEXTS.COUNTRIES.KENYA },
  { value: "Kiribati", label: TEXTS.COUNTRIES.KIRIBATI },
  { value: "Kuwait", label: TEXTS.COUNTRIES.KUWAIT },
  { value: "Kyrgyzstan", label: TEXTS.COUNTRIES.KYRGYZSTAN },
  { value: "Laos", label: TEXTS.COUNTRIES.LAOS },
  { value: "Latvia", label: TEXTS.COUNTRIES.LATVIA },
  { value: "Lebanon", label: TEXTS.COUNTRIES.LEBANON },
  { value: "Lesotho", label: TEXTS.COUNTRIES.LESOTHO },
  { value: "Liberia", label: TEXTS.COUNTRIES.LIBERIA },
  { value: "Libya", label: TEXTS.COUNTRIES.LIBYA },
  { value: "Liechtenstein", label: TEXTS.COUNTRIES.LIECHTENSTEIN },
  { value: "Lithuania", label: TEXTS.COUNTRIES.LITHUANIA },
  { value: "Luxembourg", label: TEXTS.COUNTRIES.LUXEMBOURG },
  { value: "Macao", label: TEXTS.COUNTRIES.MACAO },
  { value: "Macedonia", label: TEXTS.COUNTRIES.MACEDONIA },
  { value: "Madagascar", label: TEXTS.COUNTRIES.MADAGASCAR },
  { value: "Malawi", label: TEXTS.COUNTRIES.MALAWI },
  { value: "Malaysia", label: TEXTS.COUNTRIES.MALAYSIA },
  { value: "Maldives", label: TEXTS.COUNTRIES.MALDIVES },
  { value: "Mali", label: TEXTS.COUNTRIES.MALI },
  { value: "Malta", label: TEXTS.COUNTRIES.MALTA },
  {
    value: "Marshall Islands",
    label: TEXTS.COUNTRIES.MARSHALL_ISLANDS,
  },
  { value: "Mauritania", label: TEXTS.COUNTRIES.MAURITANIA },
  { value: "Mauritius", label: TEXTS.COUNTRIES.MAURITIUS },
  { value: "Mayotte", label: TEXTS.COUNTRIES.MAYOTTE },
  { value: "Mexico", label: TEXTS.COUNTRIES.MEXICO },
  { value: "Micronesia", label: TEXTS.COUNTRIES.MICRONESIA },
  { value: "Moldova", label: TEXTS.COUNTRIES.MOLDOVA },
  { value: "Monaco", label: TEXTS.COUNTRIES.MONACO },
  { value: "Mongolia", label: TEXTS.COUNTRIES.MONGOLIA },
  { value: "Montenegro", label: TEXTS.COUNTRIES.MONTENEGRO },
  { value: "Montserrat", label: TEXTS.COUNTRIES.MONTSERRAT },
  { value: "Morocco", label: TEXTS.COUNTRIES.MOROCCO },
  { value: "Mozambique", label: TEXTS.COUNTRIES.MOZAMBIQUE },
  { value: "Myanmar", label: TEXTS.COUNTRIES.MYANMAR },
  { value: "Namibia", label: TEXTS.COUNTRIES.NAMIBIA },
  { value: "Nauru", label: TEXTS.COUNTRIES.NAURU },
  { value: "Nepal", label: TEXTS.COUNTRIES.NEPAL },
  { value: "Netherlands", label: TEXTS.COUNTRIES.NETHERLANDS },
  { value: "New Caledonia", label: TEXTS.COUNTRIES.NEW_CALEDONIA },
  { value: "New Zealand", label: TEXTS.COUNTRIES.NEW_ZEALAND },
  { value: "Nicaragua", label: TEXTS.COUNTRIES.NICARAGUA },
  { value: "Niger", label: TEXTS.COUNTRIES.NIGER },
  { value: "Nigeria", label: TEXTS.COUNTRIES.NIGERIA },
  { value: "Niue", label: TEXTS.COUNTRIES.NIUE },
  { value: "North Korea", label: TEXTS.COUNTRIES.NORTH_KOREA },
  {
    value: "Northern Mariana Islands",
    label: TEXTS.COUNTRIES.NORTHERN_MARIANA_ISLANDS,
  },
  { value: "Norway", label: TEXTS.COUNTRIES.NORWAY },
  { value: "Oman", label: TEXTS.COUNTRIES.OMAN },
  { value: "Pakistan", label: TEXTS.COUNTRIES.PAKISTAN },
  { value: "Palau", label: TEXTS.COUNTRIES.PALAU },
  { value: "Palestine", label: TEXTS.COUNTRIES.PALESTINE },
  { value: "Panama", label: TEXTS.COUNTRIES.PANAMA },
  {
    value: "Papua New Guinea",
    label: TEXTS.COUNTRIES.PAPUA_NEW_GUINEA,
  },
  { value: "Paraguay", label: TEXTS.COUNTRIES.PARAGUAY },
  { value: "Peru", label: TEXTS.COUNTRIES.PERU },
  { value: "Philippines", label: TEXTS.COUNTRIES.PHILIPPINES },
  { value: "Pitcairn", label: TEXTS.COUNTRIES.PITCAIRN },
  { value: "Poland", label: TEXTS.COUNTRIES.POLAND },
  { value: "Portugal", label: TEXTS.COUNTRIES.PORTUGAL },
  { value: "Puerto Rico", label: TEXTS.COUNTRIES.PUERTO_RICO },
  { value: "Qatar", label: TEXTS.COUNTRIES.QATAR },
  { value: "Reunion", label: TEXTS.COUNTRIES.REUNION },
  { value: "Romania", label: TEXTS.COUNTRIES.ROMANIA },
  { value: "Russia", label: TEXTS.COUNTRIES.RUSSIA },
  { value: "Rwanda", label: TEXTS.COUNTRIES.RWANDA },
  { value: "Saint Helena", label: TEXTS.COUNTRIES.SAINT_HELENA },
  { value: "Saint Helena", label: TEXTS.COUNTRIES.SAINT_HELENA },
  {
    value: "Saint Kitts and Nevis",
    label: TEXTS.COUNTRIES.SAINT_KITTS_AND_NEVIS,
  },
  { value: "Saint Lucia", label: TEXTS.COUNTRIES.SAINT_LUCIA },
  { value: "Saint Martin", label: TEXTS.COUNTRIES.SAINT_MARTIN },
  {
    value: "Saint Pierre and Miquelon",
    label: TEXTS.COUNTRIES.SAINT_PIERRE_AND_MIQUELON,
  },
  {
    value: "Saint Vincent and The Grenadines",
    label: TEXTS.COUNTRIES.SAINT_VINCENT_AND_THE_GRENADINES,
  },
  { value: "Samoa", label: TEXTS.COUNTRIES.SAMOA },
  { value: "San Marino", label: TEXTS.COUNTRIES.SAN_MARINO },
  {
    value: "Sao Tome and Principe",
    label: TEXTS.COUNTRIES.SAO_TOME_AND_PRINCIPE,
  },
  { value: "Saudi Arabia", label: TEXTS.COUNTRIES.SAUDI_ARABIA },
  { value: "Senegal", label: TEXTS.COUNTRIES.SENEGAL },
  { value: "Serbia", label: TEXTS.COUNTRIES.SERBIA },
  { value: "Seychelles", label: TEXTS.COUNTRIES.SEYCHELLES },
  { value: "Sierra Leone", label: TEXTS.COUNTRIES.SIERRA_LEONE },
  { value: "Singapore", label: TEXTS.COUNTRIES.SINGAPORE },
  { value: "Sint Maarten", label: TEXTS.COUNTRIES.SINT_MAARTEN },
  { value: "Slovakia", label: TEXTS.COUNTRIES.SLOVAKIA },
  { value: "Slovenia", label: TEXTS.COUNTRIES.SLOVENIA },
  {
    value: "Solomon Islands",
    label: TEXTS.COUNTRIES.SOLOMON_ISLANDS,
  },
  { value: "Somalia", label: TEXTS.COUNTRIES.SOMALIA },
  { value: "South Africa", label: TEXTS.COUNTRIES.SOUTH_AFRICA },
  { value: "South Korea", label: TEXTS.COUNTRIES.SOUTH_KOREA },
  { value: "South Sudan", label: TEXTS.COUNTRIES.SOUTH_SUDAN },
  { value: "Spain", label: TEXTS.COUNTRIES.SPAIN },
  { value: "Sri Lanka", label: TEXTS.COUNTRIES.SRI_LANKA },
  { value: "Sudan", label: TEXTS.COUNTRIES.SUDAN },
  { value: "Suriname", label: TEXTS.COUNTRIES.SURINAME },
  {
    value: "Svalbard and Jan Mayen",
    label: TEXTS.COUNTRIES.SVALBARD_AND_JAN_MAYEN,
  },
  { value: "Sweden", label: TEXTS.COUNTRIES.SWEDEN },
  { value: "Switzerland", label: TEXTS.COUNTRIES.SWITZERLAND },
  { value: "Syria", label: TEXTS.COUNTRIES.SYRIA },
  { value: "Taiwan", label: TEXTS.COUNTRIES.TAIWAN },
  { value: "Tajikistan", label: TEXTS.COUNTRIES.TAJIKISTAN },
  { value: "Tanzania", label: TEXTS.COUNTRIES.TANZANIA },
  { value: "Thailand", label: TEXTS.COUNTRIES.THAILAND },
  { value: "Timor-leste", label: TEXTS.COUNTRIES.TIMOR_LESTE },
  { value: "Togo", label: TEXTS.COUNTRIES.TOGO },
  { value: "Tokelau", label: TEXTS.COUNTRIES.TOKELAU },
  { value: "Tonga", label: TEXTS.COUNTRIES.TONGA },
  {
    value: "Trinidad and Tobago",
    label: TEXTS.COUNTRIES.TRINIDAD_AND_TOBAGO,
  },
  { value: "Tunisia", label: TEXTS.COUNTRIES.TUNISIA },
  { value: "Turkey", label: TEXTS.COUNTRIES.TURKEY },
  { value: "Turkmenistan", label: TEXTS.COUNTRIES.TURKMENISTAN },
  {
    value: "Turks and Caicos Islands",
    label: TEXTS.COUNTRIES.TURKS_AND_CAICOS_ISLANDS,
  },
  { value: "Tuvalu", label: TEXTS.COUNTRIES.TUVALU },
  {
    value: "U.S. Virgin Islands",
    label: TEXTS.COUNTRIES.US_VIRGIN_ISLANDS,
  },
  { value: "Uganda", label: TEXTS.COUNTRIES.UGANDA },
  { value: "Ukraine", label: TEXTS.COUNTRIES.UKRAINE },
  {
    value: "United Arab Emirates",
    label: TEXTS.COUNTRIES.UNITED_ARAB_EMIRATES,
  },
  { value: "United Kingdom", label: TEXTS.COUNTRIES.UNITED_KINGDOM },
  { value: "United States", label: TEXTS.COUNTRIES.UNITED_STATES },
  { value: "Uruguay", label: TEXTS.COUNTRIES.URUGUAY },
  { value: "Uzbekistan", label: TEXTS.COUNTRIES.UZBEKISTAN },
  { value: "Vanuatu", label: TEXTS.COUNTRIES.VANUATU },
  { value: "Vatican", label: TEXTS.COUNTRIES.VATICAN },
  { value: "Venezuela", label: TEXTS.COUNTRIES.VENEZUELA },
  { value: "Vietnam", label: TEXTS.COUNTRIES.VIETNAM },
  {
    value: "Wallis and Futuna",
    label: TEXTS.COUNTRIES.WALLIS_AND_FUTUNA,
  },
  { value: "Western Sahara", label: TEXTS.COUNTRIES.WESTERN_SAHARA },
  { value: "Yemen", label: TEXTS.COUNTRIES.YEMEN },
  { value: "Zambia", label: TEXTS.COUNTRIES.ZAMBIA },
  { value: "Zimbabwe", label: TEXTS.COUNTRIES.ZIMBABWE },
];

const languageOptions = [
  { value: "Arabic", label: TEXTS.LANGUAGES.ARABIC },
  { value: "Bengali", label: TEXTS.LANGUAGES.BENGALI },
  { value: "Chinese", label: TEXTS.LANGUAGES.CHINESE },
  { value: "English", label: TEXTS.LANGUAGES.ENGLISH },
  { value: "French", label: TEXTS.LANGUAGES.FRENCH },
  { value: "German", label: TEXTS.LANGUAGES.GERMAN },
  { value: "Gujarati", label: TEXTS.LANGUAGES.GUJARATI },
  { value: "Hindi", label: TEXTS.LANGUAGES.HINDI },
  { value: "Indonesian", label: TEXTS.LANGUAGES.INDONESIAN },
  { value: "Italian", label: TEXTS.LANGUAGES.ITALIAN },
  { value: "Japanese", label: TEXTS.LANGUAGES.JAPANESE },
  { value: "Javanese", label: TEXTS.LANGUAGES.JAVANESE },
  { value: "Kannada", label: TEXTS.LANGUAGES.KANNADA },
  { value: "Korean", label: TEXTS.LANGUAGES.KOREAN },
  { value: "Malay", label: TEXTS.LANGUAGES.MALAY },
  { value: "Malayalam", label: TEXTS.LANGUAGES.MALAYALAM },
  { value: "Marathi", label: TEXTS.LANGUAGES.MARATHI },
  { value: "Oriya", label: TEXTS.LANGUAGES.ORIYA },
  { value: "Persian", label: TEXTS.LANGUAGES.PERSIAN },
  { value: "Polish", label: TEXTS.LANGUAGES.POLISH },
  { value: "Portuguese", label: TEXTS.LANGUAGES.PORTUGUESE },
  { value: "Punjabi", label: TEXTS.LANGUAGES.PUNJABI },
  { value: "Russian", label: TEXTS.LANGUAGES.RUSSIAN },
  { value: "Spanish", label: TEXTS.LANGUAGES.SPANISH },
  { value: "Tamil", label: TEXTS.LANGUAGES.TAMIL },
  { value: "Telugu", label: TEXTS.LANGUAGES.TELUGU },
  { value: "Turkish", label: TEXTS.LANGUAGES.TURKISH },
  { value: "Urdu", label: TEXTS.LANGUAGES.URDU },
  { value: "Vietnamese", label: TEXTS.LANGUAGES.VIETNAMESE },
  { value: "Wu", label: TEXTS.LANGUAGES.WU },
];

export const WORKFLOW_ICONS: {
  [key: string]: {
    color: string;
    image?: string;
    borderColor: string;
    icon?: LucideIcon | NoxusIcon;
  };
} = {
  /* Nodes */
  categorizer: {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/categorizer.svg",
    borderColor: "#166534",
  },
  "combine-text": {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/combine-text.svg",
    borderColor: "#334155",
  },
  condition: {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/condition.svg",
    borderColor: "#334155",
  },
  "document-qa": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/document-qa.svg",
    borderColor: "#166534",
  },
  "enrich-company": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/enrich-company.svg",
    borderColor: "#166534",
  },
  "extract-fields": {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/extract-fields.svg",
    borderColor: "#334155",
  },
  "file-text": {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/file-text.svg",
    borderColor: "#1E40AF",
  },
  "fill-form": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/fill-form.svg",
    borderColor: "#166534",
  },
  "find-documents": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/find-documents.svg",
    borderColor: "#166534",
  },
  "fixed-input": {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/fixed-input.svg",
    borderColor: "#5B21B6",
  },
  "generate-image": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/generate-image.svg",
    borderColor: "#166534",
  },
  "generate-text": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/generate-text.svg",
    borderColor: "#166534",
  },
  globe: {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/globe.svg",
    borderColor: "#1E40AF",
  },
  grid: {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/grid.svg",
    borderColor: "#1E40AF",
  },
  input: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/input.svg",
    borderColor: "#5B21B6",
  },
  "interpret-image": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/interpret-image.svg",
    borderColor: "#166534",
  },
  "list-single": {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/list-single.svg",
    borderColor: "#334155",
  },
  "list-web": {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/list-web.svg",
    borderColor: "#1E40AF",
  },
  "logical-or": {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/logical-or.svg",
    borderColor: "#334155",
  },
  output: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/output.svg",
    borderColor: "#5B21B6",
  },
  scorer: {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/scorer.svg",
    borderColor: "#166534",
  },
  scrape: {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/scrape.svg",
    borderColor: "#166534",
  },
  "search-engine": {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/search-engine.svg",
    borderColor: "#1E40AF",
  },
  "single-list": {
    color: "#F1F5F9",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/single-list.svg",
    borderColor: "#334155",
  },
  "text-file": {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/text-file.svg",
    borderColor: "#1E40AF",
  },
  "transform-image": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/transform-image.svg",
    borderColor: "#166534",
  },
  "translate-text": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/translate-text.svg",
    borderColor: "#166534",
  },
  "web-research": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/web-research.svg",
    borderColor: "#166534",
  },
  "generate-fields": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/nodes/structureddata2.svg",
    borderColor: "#166534",
  },
  "google-sheets": {
    color: "#DCFCE7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/google-sheets.svg",
    borderColor: "#166534",
  },
  linkedin: {
    color: "#DBEAFE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/logos/linkedin.svg",
    borderColor: "#1E40AF",
  },
  workflow: {
    color: "var(--accent)",
    icon: Workflow,
    borderColor: "var(--foreground)",
  },
  "inbox-filter": {
    color: "#EDE9FE",
    icon: Filter,
    borderColor: "#5B21B6",
  },
  "inbox-extraction": {
    color: "#FEF3C7",
    icon: ScanSearch,
    borderColor: "#92400E",
  },
  "inbox-process": {
    color: "#DCFCE7",
    icon: Network,
    borderColor: "#166534",
  },
  /* Icons */
  axe: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/axe.svg",
    borderColor: "#9D174D",
  },
  bean: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/bean.svg",
    borderColor: "#92400E",
  },
  bomb: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/bomb.svg",
    borderColor: "#92400E",
  },
  bone: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/bone.svg",
    borderColor: "#92400E",
  },
  brick: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/brick.svg",
    borderColor: "#5B21B6",
  },
  "circle-d": {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/circle-d.svg",
    borderColor: "#9D174D",
  },
  clouds: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/clouds.svg",
    borderColor: "#9D174D",
  },
  cone: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/cone.svg",
    borderColor: "#9D174D",
  },
  crown: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/crown.svg",
    borderColor: "#9D174D",
  },
  geometry: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/geometry.svg",
    borderColor: "#5B21B6",
  },
  letter: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/letter.svg",
    borderColor: "#9D174D",
  },
  muscle: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/muscle.svg",
    borderColor: "#92400E",
  },
  plant: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/plant.svg",
    borderColor: "#5B21B6",
  },
  rock: {
    color: "#FCE7F3",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/rock.svg",
    borderColor: "#9D174D",
  },
  ribbon: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/ribbon.svg",
    borderColor: "#92400E",
  },
  smile: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/smile.svg",
    borderColor: "#5B21B6",
  },
  steto: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/steto.svg",
    borderColor: "#5B21B6",
  },
  tamago: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/tamago.svg",
    borderColor: "#92400E",
  },
  tent: {
    color: "#EDE9FE",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/tent.svg",
    borderColor: "#5B21B6",
  },
  trophy: {
    color: "#FEF3C7",
    image:
      "https://storage.googleapis.com/image-storage-spot-manual/icons/trophy.svg",
    borderColor: "#92400E",
  },
  coworker: {
    color: "var(--accent)",
    icon: BotMessageSquare,
    borderColor: "var(--foreground)",
  },
  kb: {
    color: "#FEF3C7",
    icon: BookOpen,
    borderColor: "#92400E",
  },
  table: {
    color: "#DBEAFE",
    icon: Table2,
    borderColor: "#1E40AF",
  },
  inbox: {
    color: "var(--accent)",
    icon: Inbox,
    borderColor: "var(--foreground)",
  },
  /* New Icons */
  cpu: {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: Cpu,
  },
  phone: {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: Phone,
  },
  database: {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: Database,
  },
  cloud: {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: Cloud,
  },
  "shield-check": {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: ShieldCheck,
  },
  factory: {
    borderColor: "#5B21B6",
    color: "#EDE9FE",
    icon: Factory,
  },
  building: {
    borderColor: "#5B21B6",
    color: "#EDE9FE",
    icon: Building2,
  },
  bolt: {
    borderColor: "#5B21B6",
    color: "#EDE9FE",
    icon: Bolt,
  },
  truck: {
    borderColor: "#5B21B6",
    color: "#EDE9FE",
    icon: Truck,
  },
  mountain: {
    borderColor: "#5B21B6",
    color: "#EDE9FE",
    icon: Mountain,
  },
  banknote: {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: Banknote,
  },
  trending: {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: TrendingUp,
  },
  "shield-alert": {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: ShieldAlert,
  },
  home: {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: Home,
  },
  briefcase: {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: Briefcase,
  },
  heart: {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Heart,
  },
  pill: {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Pill,
  },
  flask: {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: FlaskConical,
  },
  dna: {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Dna,
  },
  stethoscope: {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Stethoscope,
  },
  book: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: BookOpen,
  },
  landmark: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Landmark,
  },
  library: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Library,
  },
  gavel: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Gavel,
  },
  siren: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Siren,
  },
  "shopping-cart": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: ShoppingCart,
  },
  "shopping-bag": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: ShoppingBag,
  },
  coffee: {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Coffee,
  },
  shirt: {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Shirt,
  },
  smartphone: {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Smartphone,
  },
  package: {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Package,
  },
  shield: {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Shield,
  },
  key: {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: KeyRound,
  },
  "app-window": {
    color: "#DCFCE7",
    borderColor: "#166534",
    icon: AppWindow,
  },
  plug: {
    color: "#FEF3C7",
    borderColor: "#92400E",
    icon: Plug,
  },
  zap: {
    color: "#EBE9FE",
    borderColor: "#5925DC",
    icon: Zap,
  },
  /* New ones */
  "git-branch-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: GitBranch,
  },
  "brain-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Brain,
  },
  "workflow-pink": {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Workflow,
  },
  "database-pink": {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Database,
  },
  "mail-pink": {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: Mail,
  },
  "bot-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Bot,
  },
  "ticket-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Ticket,
  },
  "check-circle-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: CheckCircle,
  },
  "book-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Book,
  },
  "message-square-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: MessageSquare,
  },
  "database-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: Database,
  },
  "user-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: User,
  },
  "calendar-check-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: CalendarCheck,
  },
  "user-plus-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: UserPlus,
  },
  "search-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Search,
  },
  "database-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Database,
  },
  "calendar-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Calendar,
  },
  "mail-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Mail,
  },
  "user-circle-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: UserCircle,
  },
  "git-branch-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: GitBranch,
  },
  "book-open-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: BookOpen,
  },
  "hard-drive-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: HardDrive,
  },
  "alert-circle-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: AlertCircle,
  },
  /* Template Icons - Blue */
  "headset-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Headset,
  },
  "search-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Search,
  },
  "checkcircle-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: CheckCircle,
  },
  "zap-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Zap,
  },
  "brain-blue": {
    color: "#DBEAFE",
    borderColor: "#1E40AF",
    icon: Brain,
  },
  /* Template Icons - Red */
  "ticket-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Ticket,
  },
  "bookopen-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: BookOpen,
  },
  "search-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: Search,
  },
  "filetext-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: FileText,
  },
  "listchecks-red": {
    color: "#FFE4E6",
    borderColor: "#9F1239",
    icon: ListChecks,
  },
  /* Template Icons - Purple */
  "notebookpen-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: NotebookPen,
  },
  "headset-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: Headset,
  },
  "book-purple": {
    color: "#EDE9FE",
    borderColor: "#5B21B6",
    icon: Book,
  },
  /* Template Icons - Pink */
  "scantext-pink": {
    color: "#FCE7F3",
    borderColor: "#9D174D",
    icon: ScanText,
  },
  /* Template Icons - Gray */
  "filetext-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: FileText,
  },
  "book-gray": {
    color: "#F1F5F9",
    borderColor: "#334155",
    icon: Book,
  },
  /* Template Icons - Green */
  "users-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Users,
  },
  "database-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Database,
  },
  "fileup-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: FileUp,
  },
  "send-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Send,
  },
  "brain-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Brain,
  },
  "mail-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Mail,
  },
  "gitbranch-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: GitBranch,
  },
  "bookopen-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: BookOpen,
  },
  "harddrive-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: HardDrive,
  },
  "alertcircle-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: AlertCircle,
  },
  "filespreadsheet-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: FileSpreadsheet,
  },
  "gitcompare-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: GitCompare,
  },
  "building2-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: Building2,
  },
  "usercheck-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: UserCheck,
  },
  "filecheck-green": {
    color: "#CCFBF1",
    borderColor: "#115E59",
    icon: FileCheck,
  },
};

export const ICON_GROUPS: {
  title: string;
  icons: (keyof typeof WORKFLOW_ICONS)[];
}[] = [
  {
    title: "Icons",
    // Ordered by palette hue so same-coloured icons sit together.
    icons: [
      "cpu",
      "phone",
      "database",
      "cloud",
      "shield-check",
      "generate-text",
      "document-qa",
      "find-documents",
      "web-research",
      "categorizer",
      "enrich-company",
      "fill-form",
      "interpret-image",
      "scorer",
      "transform-image",
      "translate-text",
      "scrape",
      "book",
      "landmark",
      "library",
      "gavel",
      "siren",
      "file-text",
      "list-web",
      "globe",
      "text-file",
      "search-engine",
      "grid",
      "factory",
      "building",
      "bolt",
      "truck",
      "mountain",
      "heart",
      "pill",
      "flask",
      "dna",
      "stethoscope",
      "shopping-cart",
      "shopping-bag",
      "coffee",
      "shirt",
      "smartphone",
      "banknote",
      "trending",
      "shield-alert",
      "home",
      "briefcase",
      "kb",
      "combine-text",
      "condition",
      "logical-or",
      "extract-fields",
      "list-single",
      "single-list",
      "workflow",
      "coworker",
    ],
  },
];
